import React, { Component } from "react";
import Drawer from "@material-ui/core/Drawer";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Trans, withTranslation } from "react-i18next";
import { setMenu, setUser } from "./../../redux/actions/universalActions";
import { setLayouts } from "./../../redux/actions/layoutActions";
import { editTheme } from "./../../redux/actions/themeActions";
import MenuItem from "./MenuItem";
import EditIcon from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import ReplayIcon from "@material-ui/icons/Replay";
import AreYouSureDialog from "./../dialog/AreYouSureDialog";
import { withRouter } from "react-router-dom";
import axios, { attachmentClient } from "../../AxiosClient";
import PubSub from "pubsub-js";
import { MENU_PORTLET_UPDATE, LOGOUT } from "../../utils/Topics";
import { createMuiTheme } from "@material-ui/core/styles";
import {
  Role,
  currentUserHasRoleId,
  currentUserHasRole,
} from "../../utils/RoleUtils";
import { Typography } from "@material-ui/core";
import Avatar from "@material-ui/core/Avatar";
import defaultLogo from "../../images/default-logo.svg";
import Resizer from "react-image-file-resizer";

const styles = (theme) => ({
  drawerHeader: {
    [theme.breakpoints.down("sm")]: {
      width: window.innerWidth / 1.25,
    },
    [theme.breakpoints.up("md")]: {
      width: window.innerWidth / 2,
    },
    [theme.breakpoints.up("lg")]: {
      width: window.innerWidth / 4,
    },
    minHeight: "225px",
    backgroundColor: theme.palette.primary.dark,
    backgroundSize: "40%",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    position: "relative",
  },
  drawerContents: {
    [theme.breakpoints.down("sm")]: {
      width: window.innerWidth / 1.25,
    },
    [theme.breakpoints.up("md")]: {
      width: window.innerWidth / 2,
    },
    [theme.breakpoints.up("lg")]: {
      width: window.innerWidth / 4,
    },
  },
  profileImage: {
    height: "46px",
    width: "46px",
    borderRadius: "50%",
    cursor: "pointer",
  },
  headerActionsWrapper: {
    display: "flex",
    margin: "10px",
  },
  logout: {
    marginLeft: "auto",
    color: theme.palette.primary.contrastText,
    cursor: "pointer",
    fontFamily: theme.typography.fontFamily,
  },
  backIcon: {
    color: theme.palette.primary.contrastText,
  },
  name: {
    color: theme.palette.primary.contrastText,
    position: "absolute",
    bottom: "0",
    marginLeft: "10px",
    marginBottom: "5px",
    fontFamily: theme.typography.fontFamily,
  },
  breadcrumbs: {
    color: theme.palette.primary.contrastText,
    position: "absolute",
    bottom: "0",
    left: "0",
    marginLeft: "5px",
  },
  inactiveCrumb: {
    color: theme.palette.grey[300],
    cursor: "pointer",
  },
  activeCrumb: {
    color: theme.palette.primary.contrastText,
  },
  editButton: {
    position: "absolute",
    bottom: 5,
    right: 5,
    display: "flex",
  },
  editIcon: {
    color: theme.palette.primary.contrastText,
  },
});

export class PortalDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [{ name: "Home" }],
      selected: 0,
      mainMenu: true,
      editMode: false,
      // instance: new Date().getTime().toString(),
      resetDialogOpen: false,
      // numberOfSectionsViewable: 0,
      // numberOfSectionsNotViewable: 0,
      oneSection: false,
      logo: "",
    };
  }
  // componentDidUpdate(prevProps, prevState) {
  //   if (this.state.numberOfSectionsNotViewable + this.state.numberOfSectionsViewable === this.props.menuItems.length && this.state.numberOfSectionsViewable === 1 && !this.state.oneSection) {
  //     this.setState({ oneSection: true });
  //   } else if (this.state.numberOfSectionsNotViewable + this.state.numberOfSectionsViewable === this.props.menuItems.length && this.state.numberOfSectionsViewable !== 1 && this.state.oneSection) {
  //     this.setState({ oneSection: false });
  //   }
  // }
  componentDidMount() {
    this.oneSectionOption();
    this.getOrgLogo();
  }

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        300,
        300,
        "PNG",
        100,
        0,
        (uri) => {
          resolve(uri);
          this.setState({ logo: uri });
        },
        "base64"
      );
    });

  getOrgLogo() {
    fetch(
      `https://${this.props.apiLocation}/taxonomyservice/organization/${
        this.props.currentUser.organization.organizationId
      }/logo`,
      { responseType: "blob", credentials: 'include'}
    )
      .then((res) => {
        if (res.ok) {
          res
            .blob()
            .then((blob) => {
              this.resizeFile(blob);
            })
            .catch(() => {
              this.setState({ logo: defaultLogo });
            });
        } else {
          this.setState({ logo: defaultLogo });
        }
      })
      .catch(() => {
        this.setState({ logo: defaultLogo });
      });
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <DragDropContext onDragEnd={this.onDragEnd}>
          <Drawer open={this.props.open} onClose={this.props.onClose}>
            <div
              className={classes.drawerHeader}
              style={{
                backgroundImage: `url(${this.state.logo})`,
              }}
            >
              <div className={classes.headerActionsWrapper}>
                {this.state.mainMenu ? (
                  <Tooltip
                    title={
                      <Typography>
                        <Trans i18nKey="portal_drawer_update_profile" />
                      </Typography>
                    }
                  >
                    <Avatar
                      src={this.props.currentUser.avatarBase64}
                      className={classes.profileImage}
                      onClick={this.openProfilePage}
                      aria-label="Open profile page"
                      alt="Profile picture"
                      tabindex={0}
                    />
                  </Tooltip>
                ) : (
                  <IconButton
                    onClick={this.previousMenu}
                    className={classes.backIcon}
                  >
                    <ArrowBackIcon />
                  </IconButton>
                )}
                <div
                  onClick={this._logout}
                  className={classes.logout}
                  tabindex={0}
                >
                  <Trans i18nKey="drawer_logout" />
                </div>
              </div>
              <div className={classes.name}>
                {this.props.currentUser.firstName}{" "}
                {this.props.currentUser.surname}
                <br />
                {this.props.currentUser.email}
              </div>
              <div className={classes.editButton}>
                <>
                  {this.state.editMode &&
                    this.props.currentUser.userPermits.roles.administrator && (
                      <div>
                        <Tooltip
                          title={
                            <Typography>
                              {this.props.t("admin_reset_menu_tooltip")}
                            </Typography>
                          }
                        >
                          <IconButton
                            onClick={this.openResetDialog}
                            className={classes.editIcon}
                            aria-label="Reset to default settings"
                          >
                            <ReplayIcon />
                          </IconButton>
                        </Tooltip>

                        <AreYouSureDialog
                          open={this.state.resetDialogOpen}
                          onClose={this.closeResetDialog}
                          onSubmit={this.resetToDefault}
                        >
                          <Trans i18nKey="admin_reset_menu_body" />
                        </AreYouSureDialog>
                      </div>
                    )}
                  {this.props.currentUser.userPermits != null && (
                    // this.props.currentUser.userPermits.roles.administrator && (
                    <Tooltip
                      title={
                        <Typography>
                          {this.props.t("edit_menu_tooltip")}
                        </Typography>
                      }
                    >
                      <IconButton
                        aria-label={"edit-menu"}
                        onClick={this.editMenu}
                        className={classes.editIcon}
                      >
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                </>
              </div>
            </div>
            <Droppable droppableId="top-droppable" type="top">
              {(dropProvided, dropSnapshot) => (
                <>
                  <div
                    className={classes.drawerContents}
                    ref={dropProvided.innerRef}
                    {...dropProvided.droppableProps}
                  >
                    {this.props.menuItems.map((ele, idx) => {
                      if (!this.userCanView(ele)) {
                        return null;
                      } else {
                        return (
                          <MenuItem
                            // addIfViewable={(viewable) => this.addIfViewable(viewable)}
                            onlySection={this.state.oneSection}
                            onClose={this.props.onClose}
                            key={ele.id}
                            topLevel
                            depth={0}
                            item={ele}
                            editMode={this.state.editMode}
                            handleDrop={this.handleItemDrop}
                            index={idx}
                          />
                        );
                      }
                    })}
                    {dropProvided.placeholder}
                  </div>
                </>
              )}
            </Droppable>
          </Drawer>
        </DragDropContext>
      </div>
    );
  }
  // addIfViewable = (viewable) => {
  //   if (this.props.menuItems.length > this.state.numberOfSectionsViewable + this.state.numberOfSectionsNotViewable) {
  //     if (viewable) {
  //       this.setState({ numberOfSectionsViewable: this.state.numberOfSectionsViewable + 1 });
  //     } else {
  //       this.setState({ numberOfSectionsNotViewable: this.state.numberOfSectionsNotViewable + 1 });
  //     }
  //   }
  // }
  oneSectionOption = () => {
    let numberOfSectionsNotViewable = 0;
    let numberOfSectionsViewable = 0;
    this.props.menuItems.map((ele) => {
      if (!this.userCanView(ele)) {
        numberOfSectionsNotViewable = numberOfSectionsNotViewable + 1;
      } else {
        numberOfSectionsViewable = numberOfSectionsViewable + 1;
      }
    });
    numberOfSectionsViewable === 1 && this.setState({ oneSection: true });
  };
  userCanView = (item) => {
    if (
      this.props.isMobile &&
      (item.id === 1125 ||
        item.id === 1135 ||
        item.id === 1131 ||
        item.id === 1003 ||
        item.id === 1045 ||
        item.id === 1143 ||
        item.id === 1120 ||
        item.id === 1039 ||
        item.id === 1136 ||
        item.id === 1121 ||
        item.id === 1139 ||
        item.id === 1027 ||
        item.id === 1126 ||
        item.id === 1048 ||
        item.id === 1028)
    )
      return false;
    if (item.id === 1001 || item.id === 1002 || item.id === 1003) {
      return this.anyChildVisible(item.children);
    }
    let childVisible = true;
    if (item.children.length > 0) {
      childVisible = this.anyChildVisible(item.children);
    }

    for (const roleId of item.requiredRoles) {
      if (currentUserHasRoleId(roleId) && childVisible) {
        return true;
      }
    }
    return false;
  };

  anyChildVisible = (children) => {
    for (const child of children) {
      if (this.userCanView(child)) {
        return true;
      }
      if (child.children.length > 0) {
        if (this.anyChildVisible(child.children)) {
          return true;
        }
      }
    }
    return false;
  };

  openResetDialog = () => {
    this.setState({ resetDialogOpen: true });
  };

  closeResetDialog = () => {
    this.setState({ resetDialogOpen: false });
  };

  resetToDefault = () => {
    axios.post("/menuportlet/reset").then(() => {
      PubSub.publish(MENU_PORTLET_UPDATE);
      this.closeResetDialog();
    });
  };

  onDragEnd = (result) => {
    if (!result.destination) return;

    let menu = [...this.props.menuItems];

    if (result.type === "top") {
      const [removed] = menu.splice(result.source.index, 1);
      menu.splice(result.destination.index, 0, removed);
      menu.forEach((ele, idx) => (ele.order = idx));
      axios.patch("/menuportlet/", menu).then(() => {
        this.props.setMenu(menu, 1);
      });
    } else {
      let menu = [...this.props.menuItems];
      let matchingDroppable = menu.find(
        (ele) => ele.id === result.destination.droppableId
      );
      if (!matchingDroppable) {
        for (let ele of menu) {
          let matchingChild = ele.children.find(
            (ele) => ele.id === result.destination.droppableId
          );
          if (matchingChild) {
            matchingDroppable = matchingChild;
            break;
          }
        }
      }
      if (!matchingDroppable) {
        console.warn(
          "Matching droppable destination not found: ",
          result.destination.droppableId
        );
        return;
      }
      const [removed] = matchingDroppable.children.splice(
        result.source.index,
        1
      );
      matchingDroppable.children.splice(result.destination.index, 0, removed);
      matchingDroppable.children.forEach((ele, idx) => (ele.order = idx));

      axios.patch("/menuportlet/", menu).then(() => {
        this.props.setMenu(menu, 1);
      });
    }
  };

  findChild = (items, childId) => {
    items.findIndex((ele) => ele.id === childId);
  };

  editMenu = () => {
    this.setState((prev) => ({ editMode: !prev.editMode }));
  };

  handleBreadcrumbClick = (idx) => (e) => {
    this.setState({ selected: idx });
    this.setState({ breadcrumbs: this.state.breadcrumbs.slice(0, idx + 1) });
  };

  _logout = () => {

    localStorage.removeItem("palette");

    this.props.setLayouts([]);
    this.props.setUser({});
    this.props.editTheme(
      createMuiTheme({ typography: { useNextVariants: true } })
    );
    this.props.onClose();
    PubSub.publish(LOGOUT);
  };

  previousMenu = () => {
    this.setState((prev) => ({ selected: prev.selected - 1 }));
    this.setState((prev) => {
      var bcCopy = [...prev.breadcrumbs];
      bcCopy.pop();
      return { breadcrumbs: bcCopy };
    });
  };

  setBreadcrumbs(e) {
    var crumbArray = JSON.stringify(this.state.breadcrumbs);
    crumbArray = JSON.parse(crumbArray);
    crumbArray.push({
      name: e.detail.title,
      id: new Date().getTime(),
      parents: null,
    });
    this.setState({ breadcrumbs: crumbArray });
  }

  openProfilePage = () => {
    this.props.history.push("/profile");
    this.props.onClose();
  };
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  menuItems: state.menu.firstMenu,
  apiLocation: state.setting.apiLocation,
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {
  setMenu,
  setLayouts,
  setUser,
  editTheme,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(withTranslation()(PortalDrawer)))
);
